// FB04 cart auto-reconcile: keep personalization addon and its parent jersey linked.
// If either is removed, the other gets removed too — customers can't keep a personalized
// jersey without paying the €3.90 fee, and can't keep the fee without the jersey.
(function(){
  var processing = false;
  var lastRunAt = 0;

  function reconcileCart() {
    if (processing) return;
    var now = Date.now();
    if (now - lastRunAt < 250) return; // debounce against rapid fires
    lastRunAt = now;
    processing = true;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var changes = [];
        var addons = [];
        var customJerseys = [];

        cart.items.forEach(function(item){
          var p = item.properties || {};
          if (p._addon === 'true') {
            addons.push(item);
          } else if (p.Name || p.Number) {
            customJerseys.push(item);
          }
        });

        // Orphaned addons (no matching jersey by parent_variant_id) → remove
        addons.forEach(function(addon){
          var parentVid = addon.properties._parent_variant_id;
          var hasParent = customJerseys.some(function(j){
            return String(j.variant_id) === String(parentVid);
          });
          if (!hasParent) {
            changes.push({ id: addon.key, quantity: 0, label: 'orphan-addon' });
          }
        });

        // Customized jerseys without their addon → remove
        customJerseys.forEach(function(jersey){
          var hasAddon = addons.some(function(a){
            var paired = String(a.properties._parent_variant_id) === String(jersey.variant_id);
            // Also make sure the addon wasn't already marked for removal
            return paired && !changes.some(function(c){ return c.id === a.key && c.label === 'orphan-addon'; });
          });
          if (!hasAddon) {
            changes.push({ id: jersey.key, quantity: 0, label: 'orphan-jersey' });
          }
        });

        if (changes.length === 0) {
          processing = false;
          return;
        }

        // Apply removals sequentially
        var p = Promise.resolve();
        changes.forEach(function(change){
          p = p.then(function(){
            return fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: change.id, quantity: 0 })
            }).then(function(r){ return r.json(); });
          });
        });

        p.then(function(){
          return fetch('/cart.js', { credentials: 'same-origin' }).then(function(r){ return r.json(); });
        }).then(function(freshCart){
          // Notify Horizon to refresh the drawer + count
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { data: freshCart, resource: freshCart, source: 'fb4-reconcile' }
          }));
          processing = false;
        }).catch(function(){ processing = false; });
      })
      .catch(function(){ processing = false; });
  }

  // Hook into Horizon's cart:update event with a small delay so our reconcile runs AFTER
  // their handlers finish updating the DOM.
  document.addEventListener('cart:update', function(e){
    // Don't react to our own reconcile-fired updates (avoid feedback loop)
    if (e && e.detail && e.detail.source === 'fb4-reconcile') return;
    setTimeout(reconcileCart, 120);
  });

  // Run once on load in case the page reloaded with a stale orphaned state.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(reconcileCart, 500); });
  } else {
    setTimeout(reconcileCart, 500);
  }
})();
